
import { Page, ButtonGroup, Button, TextField, Modal, Icon, EmptyState, Pagination, FooterHelp, Link, Card, BlockStack, InlineStack } from '@shopify/polaris';
import { DI, DIProps } from '../../../../Core';
import { SearchMinor, ViewMajor, CircleInformationMajor } from '@shopify/polaris-icons';
import React, { useState, useEffect, useRef } from 'react';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png'
import { Table } from 'antd';
import ReactJson from "react-json-view";
import { useDebounce } from '../../useDebounce';
import { ArchievedOrderSkeleton } from '../skeleton/FailedSkeleton';
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../../Panel';
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    amazon_order_id: string;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

function ArchivedOrder(props: Props) {
    const { t } = useTranslation();
    const [inputValue, setinputValue] = useState<string>('');
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false)
    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [pageCount, setpageCount] = useState<number>(10);
    const [gridRows, setGridRows] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(false);
    const [activateViewModal, setActivateViewModal] = useState<boolean>(false);
    const [viewModalData, setViewModalData] = useState<any>({});
    const prevInput = useRef('');

    const columns = [
        {
            title: t('Order Id'),
            dataIndex: 'id',
            width: '250px',
        },
        {
            title: t('Date'),
            dataIndex: 'date',
            width: '250px',
        },
        {
            title: t('Actions'),
            dataIndex: 'actions',
            width: '100px',
        }
    ];

    const updateText = (val: string) => {
        setinputValue(val);
    }
    const handleViewBtn = (order_id: string) => {
        props.history(`../view-order/${order_id}`)
    }
    const handleViewEyeBtn = async (order_id: string) => {
        let response = await props.di.GET('connector/order/get', { order_id: order_id, marketplace_shop_id: props?.redux?.current?.target?.['_id'], marketplace: "amazon", });
        if (response.success) {
            setViewModalData({ ...response?.data });
            setActivateViewModal(!activateViewModal);
        }
    }
    const getRows = (data: any) => {
        const rows = data.map((obj: any, index: number) => {
            return {
                key: obj['cif_order_id'],
                id: obj['marketplace_reference_id'],
                date: obj?.['items']?.['attributes']?.['purchase_date'] ?? t('Not assigned yet'),
                actions: <ButtonGroup variant="segmented">
                    {props?.match?.from == "failed" && <Button onClick={() => handleViewEyeBtn(obj['cif_order_id'])} icon={ViewMajor} />}
                    <Button onClick={() => handleViewBtn(obj['cif_order_id'])}>{t("View")}</Button>
                </ButtonGroup>
            };
        });
        return rows;
    }
    const handlePreviousPagination = () => {
        setActivePage(prev => prev - 1);
    }
    const handleNextPagination = () => {
        setActivePage(prev => prev + 1);
    }
    const getArchivedOrders = async () => {
        setLoader(true);
        setShowSkeleton(false)
        let obj: any = {
            activePage: activePage,
            count: pageCount,
            "filter[user_id][1]": props.redux.user_id,
            "filter[object_type][1]": "source_order",
            "filter[marketplace][1]": "amazon",
            "filter[marketplace_shop_id][1]": props?.redux?.current?.target?._id,
            "filter[status][1]": "archived",

        };
        if (inputValue && inputValue != "") obj['filter[marketplace_reference_id][3]'] = inputValue;
        if (inputValue !== prevInput.current && activePage !== 1) {
            obj.activePage = 1;
            setActivePage(1)
            return;
        }
        let response = await props.di.GET('connector/order/getAll', obj);
        setLoader(false);
        if (response.success && response?.data?.rows.length > 0) {
            const rows = getRows(response?.data?.rows);
            setGridRows([...rows]);
            setTotalPages(Math.ceil(response?.data?.['count'] / pageCount));
            setShowSkeleton(false);
        }
        else {
            setShowSkeleton(true);
            setGridRows([]);
        }
        prevInput.current = inputValue
    }

    const debouncedValue = useDebounce(inputValue, 500)
    useEffect(() => {
        getArchivedOrders();
    }, [activePage, debouncedValue]);

    return (
        <Page
            backAction={
                {
                    content: t("Archived Orders"),
                    onAction: () => {
                        props.history(-1);
                    },
                }
            }
            title={t("Archived Orders")}
            subtitle={t('View and manage your Archived Orders with the help of your Amazon Order ID.')}
            primaryAction={
                <RenderHeadersAction {...props} />
            }
        >
            <Card roundedAbove='sm'>
                <Modal
                    open={activateViewModal}
                    onClose={() => { setActivateViewModal(!activateViewModal) }}
                    title={t("Order View")}
                >
                    <Modal.Section>
                        <ReactJson src={viewModalData} theme={"monokai"} />
                    </Modal.Section>
                </Modal>
                <BlockStack gap="200">
                    <div className='Custom-Stack-Item--fill'>
                        <TextField
                            autoComplete='off'
                            prefix={<div><Icon source={SearchMinor} tone="base" /></div>}
                            label=""
                            value={inputValue}
                            onChange={updateText}
                            placeholder={t("Search with Amazon Order Id")}
                            clearButton
                            onClearButtonClick={() => setinputValue('')}
                        />
                    </div>
                    {showSkeleton ?
                        <EmptyState
                            image={NoResultsFound}
                            heading={t("No Archived Orders Found")}
                        />
                        :

                        (<>{!loader ? (
                            <Table
                                columns={columns}
                                dataSource={gridRows}
                                scroll={{
                                    x: 600,
                                }}
                                pagination={false}
                                loading={loader}
                                size='middle'
                            />) : (<ArchievedOrderSkeleton />)
                        }
                        </>)
                    }
                    {gridRows.length > 0 &&
                        <div >
                            <InlineStack gap="400" align="center">
                                <Pagination
                                    label={`${activePage}/${totalPages}`}
                                    hasPrevious={activePage > 1 && !loader}
                                    onPrevious={() => {
                                        handlePreviousPagination()
                                    }}
                                    hasNext={activePage < totalPages && !loader}
                                    onNext={() => {
                                        handleNextPagination()
                                    }}
                                />
                            </InlineStack>
                        </div>}
                </BlockStack>
            </Card>
            <FooterHelp>
                <InlineStack align="center" gap="100">
                    <div>
                        <Icon
                            source={CircleInformationMajor}
                            tone="info"
                        />
                    </div>{t("Learn more about")}<Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024">
                        {t("CedCommerce Amazon Channel")}
                    </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                        {t("Terms & Conditions")}
                    </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                        {t("Data Privacy Rights.")}
                    </Link>{t("Need Help?")}<Link target='_blank'
                        url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
                        {t("Get Support")}
                    </Link>{t("or")}<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                        {t("Book a Call")}
                    </Link>
                </InlineStack>
            </FooterHelp>
        </Page>
    );
}

export default DI(ArchivedOrder);
